import React from 'react';
import styled from 'styled-components';

import { Grid, Row } from 'react-bootstrap';
import { CenteredCol} from '../StyledPrimitives/StyledPrimitives';
import JobsList from './JobsList';
import TimeToggledJobsContent from './TimeToggledJobsContent';
import TimeColoredCenteredCol from './TimeColoredCenteredCol';

const SameHeightRow = styled(Row)`
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
`;

const jobsContent = (props) => {
    return (
        <Grid fluid>
            <Row>
                <CenteredCol smHidden mdHidden lgHidden xs={12}>
                    <TimeToggledJobsContent />
                </CenteredCol>
            </Row>
            <SameHeightRow>
                <TimeColoredCenteredCol isDay xsHidden sm={6}>
                    <JobsList isDay/>
                </TimeColoredCenteredCol>
                <TimeColoredCenteredCol xsHidden sm={6}>
                    <JobsList/>
                </TimeColoredCenteredCol>
            </SameHeightRow>
        </Grid>
    );
};

export default jobsContent;


// WEBPACK FOOTER //
// ./src/components/Job/JobsContent.js